import { useEffect, useMemo } from "react";
import { useEditItem2 } from "../../toolympus/api/useNewItem";
import { useSpace } from "../Spaces/SpaceContext";
import { generateCode } from "../../toolympus/api/data";
import { createSelectSchema } from "../../toolympus/hooks/useSchema";
import { ProjectTag, TagColorOptions } from "../Projects/useProjectsTagsConfiguration";

export const ContactTagsSettingKey = "_sb_contact_tags";

export const useContactsTagsConfiguration = () => {
  const { settings } = useSpace();
  const tags = useEditItem2<{ tags: ProjectTag[]}>({
    save: (item) => {
      return settings.update({ [ContactTagsSettingKey]: item.tags })
        .then(x => ({ tags: x[ContactTagsSettingKey]}));
    },
    dontResetOnSave: true,
  });

  useEffect(() => {
    tags.startEditing({ tags: settings.settings[ContactTagsSettingKey] || []});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.settings]);

  return {
    ...tags,
    createDefaultTag: () => ({ code: generateCode(), label: "", color: TagColorOptions[TagColorOptions.length - 1] }),
  }
}


export const useContactsTags = () => {
  const { settings } = useSpace();
  const tags: ProjectTag[] = settings.settings[ContactTagsSettingKey] || [];

  const selectorSchema = useMemo(() => {
    const tags: ProjectTag[] = settings.settings[ContactTagsSettingKey] || [];
    return createSelectSchema(tags.map(t => ({ label: t.label, value: t.code })), { label: "Теги"});

  }, [settings.settings])

  return {
    tags,
    selectorSchema,
  }
}
